import React from 'react';

interface BookCardProps {
    book: {
        bookId: number;
        bookTitle: React.ReactNode;
        coverImage: string;
        authorName?: string;
    };
    formatTitle?: (title: React.ReactNode) => React.ReactNode;
    onClick?: (bookId: number) => void;
}

const BookCard: React.FC<BookCardProps> = ({ book, onClick }) => {

    const handleClick = () => {
        if (onClick) onClick(book.bookId);
    };

    return (
        <div
            className="cursor-pointer flex flex-col gap-2"
            onClick={handleClick}
        >
            {/* 책 표지 - 2:3 비율 */}
            <div
                className="w-full overflow-hidden rounded-[8px] shadow-[0px_2px_8px_0px_rgba(0,0,0,0.06)] bg-[#f5f5f5]"
                style={{ aspectRatio: '2/3' }}
            >
                <img
                    src={
                        book.coverImage
                            ? `data:image/png;base64,${book.coverImage}`
                            : `${process.env.PUBLIC_URL}/img/book_5.jpg`
                    }
                    alt={book.bookId as unknown as string}
                    className="object-cover w-full h-full"
                />
            </div>

            {/* 텍스트 영역 */}
            <div className="flex flex-col gap-0.5 px-0.5">
                {book.authorName && (
                    <span className="text-[#19cf7a] text-[13px] font-medium truncate">{book.authorName}</span>
                )}
                <span className="text-[#333] text-[15px] font-bold line-clamp-2 leading-snug">
                    {book.bookTitle}
                </span>
            </div>
        </div>
    );
};

export default BookCard;
